var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Button"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-button', [_vm._v("Button")])];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Different designs"
    }
  }, [_c('a-button', [_vm._v(" Primary ")]), _c('a-button', {
    attrs: {
      "design": "secondary"
    }
  }, [_vm._v(" Secondary ")]), _c('a-button', {
    attrs: {
      "design": "tertiary"
    }
  }, [_vm._v(" Tertiary ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Outlined style"
    }
  }, [_c('a-button', {
    attrs: {
      "outlined": ""
    }
  }, [_vm._v(" Primary ")]), _c('a-button', {
    attrs: {
      "design": "secondary",
      "outlined": ""
    }
  }, [_vm._v(" Secondary ")]), _c('a-button', {
    attrs: {
      "design": "tertiary",
      "outlined": ""
    }
  }, [_vm._v(" Tertiary ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Plain style"
    }
  }, [_c('a-button', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v(" Primary ")]), _c('a-button', {
    attrs: {
      "design": "secondary",
      "plain": ""
    }
  }, [_vm._v(" Secondary ")]), _c('a-button', {
    attrs: {
      "design": "tertiary",
      "plain": ""
    }
  }, [_vm._v(" Tertiary ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Disabled option"
    }
  }, [_c('a-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" Primary ")]), _c('a-button', {
    attrs: {
      "design": "secondary",
      "disabled": ""
    }
  }, [_vm._v(" Secondary ")]), _c('a-button', {
    attrs: {
      "design": "tertiary",
      "disabled": ""
    }
  }, [_vm._v(" Tertiary ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Different sizes"
    }
  }, [_c('a-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v(" Small ")]), _c('a-button', [_vm._v(" Medium ")]), _c('a-button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v(" Large ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Icon slot"
    }
  }, [_c('a-button', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_c('check-icon')];
      },
      proxy: true
    }])
  }, [_vm._v(" Button ")]), _c('a-button', {
    attrs: {
      "reversed": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_c('check-icon')];
      },
      proxy: true
    }])
  }, [_vm._v(" Reversed ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Icon-only style"
    }
  }, [_c('a-button', {
    attrs: {
      "aria-label": "Check"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_c('check-icon')];
      },
      proxy: true
    }])
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Loading option"
    }
  }, [_c('a-button', {
    attrs: {
      "loading": ""
    }
  }, [_vm._v(" Primary ")]), _c('a-button', {
    attrs: {
      "design": "secondary",
      "loading": ""
    }
  }, [_vm._v(" Secondary ")]), _c('a-button', {
    attrs: {
      "design": "tertiary",
      "loading": ""
    }
  }, [_vm._v(" Tertiary ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Custom tag (or component)"
    }
  }, [_c('a-button', {
    attrs: {
      "tag": "a",
      "href": "https://github.com/bcastlel/vue-ui-kit",
      "target": "_blank"
    }
  }, [_vm._v(" Anchor ")]), _c('a-button', {
    attrs: {
      "design": "secondary",
      "tag": "router-link",
      "to": {
        name: 'breadcrumbs'
      }
    }
  }, [_vm._v(" Router link ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }